<template>
  <b-card no-body>
    <el-table
      class="table-responsive table"
      header-row-class-name="thead-light"
      :data="data"
    >
      <el-table-column sortable label="ID" prop="name" min-width="50px">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">
                {{ row.id }}
              </span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        :label="nombreColumna"
        min-width="150px"
        prop="date"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.nombre
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column label="Editar" min-width="100px" prop="date">
        <template v-slot="{ row }">
          <b-row>
            <b-col
              ><el-button
                type="primary"
                icon="el-icon-edit"
                circle
                @click="editarElemento(row)"
              ></el-button
            ></b-col>
            <b-col
              ><el-button
                type="primary"
                icon="el-icon-delete"
                circle
                @click="eliminarElemento(row.id, row.nombre)"
              ></el-button
            ></b-col>
          </b-row>
        </template>
      </el-table-column>
    </el-table>
  </b-card>
</template>
<script>
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
  data() {
    return {
      currentPage: 1,
    };
  },
  props: ["data", "nombreColumna"],
  methods: {
    editarElemento(id) {
      this.$emit("editarElemento", id);
    },
    eliminarElemento(id, nombre) {
      swal
        .fire({
          text: `¿Esta Seguro de que desea eliminar ${nombre}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f5365c",
          cancelButtonColor: "#616365",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.$emit("eliminarElemento", id);
          }
        });
    },

    fecha_nacimiento(fecha) {
      if (fecha) {
        return fecha.split("-").reverse().join("/");
      }
    },
  },
};
</script>
<style scoped>
.separador {
  border-left: 1px solid rgb(2, 2, 2);
  height: auto;
}
</style>
